import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';
import { KitchenAngularModule } from '@inmoment/the-kitchen-angular';

import { AppSharedModule } from 'app/app-shared.module';
import { AuthGuardService, NotExecutiveGuardService } from 'app/providers/bridge-api/auth.service';
import { GroupRouteGuardService } from 'app/services/group-route-guard.service';
import { CollectionAdvancedOptionsDialogComponent } from './components/collection-advanced-options-dialog/collection-advanced-options-dialog.component';
import { FieldTypeDialogComponent } from './components/field-type-dialog/field-type-dialog.component';
import { TxEditorDialogComponent } from './components/tx-editor-dialog/tx-editor-dialog.component';
import { CollectionUploadComponent } from './pages/collection-upload/collection-upload.component';
import { UploadMapComponent } from './pages/upload-map/upload-map.component';

@NgModule({
  imports: [
    FileUploadModule,
    AppSharedModule,
    RouterModule.forRoot(
      [
        {
          canActivate: [AuthGuardService, NotExecutiveGuardService, GroupRouteGuardService],
          path: 'groups/:groupId/projects/:projectId/collections/:collectionName/upload',
          component: CollectionUploadComponent,
        },
        {
          canActivate: [AuthGuardService, NotExecutiveGuardService, GroupRouteGuardService],
          path: 'groups/:groupId/projects/:projectId/collections/:collectionName/uploads/:uploadId/map',
          component: UploadMapComponent,
        },
      ],
      {}
    ),
    KitchenAngularModule,
  ],
  providers: [],
  declarations: [
    FieldTypeDialogComponent,
    TxEditorDialogComponent,
    CollectionUploadComponent,
    UploadMapComponent,
    CollectionAdvancedOptionsDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UploadModule {}
